import { render, staticRenderFns } from "./DetailLog.vue?vue&type=template&id=70a36361&scoped=true"
import script from "./DetailLog.vue?vue&type=script&lang=js"
export * from "./DetailLog.vue?vue&type=script&lang=js"
import style0 from "./DetailLog.vue?vue&type=style&index=0&id=70a36361&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a36361",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a36361')) {
      api.createRecord('70a36361', component.options)
    } else {
      api.reload('70a36361', component.options)
    }
    module.hot.accept("./DetailLog.vue?vue&type=template&id=70a36361&scoped=true", function () {
      api.rerender('70a36361', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/DetailLog.vue"
export default component.exports